<template>
	<div class="profile">
		<img
			class="profile__image"
			:src="imageSrc"
			:height="height"
			:width="width"
			v-show="showImage"
			ref="image"
		/>
		<div class="profile__initials" v-if="!showImage">
			{{ userInitials }}
		</div>
	</div>
</template>

<script>
export default {
	name: 'ProfileImage',
	data() {
		return {
			imageLoaded: false
		};
	},
	props: {
		imageSrc: {
			type: String,
			default: undefined
		},
		height: {
			type: Number,
			default: undefined
		},
		width: {
			type: Number,
			default: undefined
		},
		firstName: {
			type: [String, Array],
			default: undefined
		},
		lastName: {
			type: [String, Array],
			default: undefined
		}
	},
	mounted() {
		const imgRef = this.$refs.image;

		imgRef.onload = this.onImageLoad;
		imgRef.onerror = this.onImageError;
	},
	computed: {
		firstNameFormatted() {
			let name = this.firstName;

			//the user firstName prop may be an array of names that come from Employee and Global Employee
			if (Array.isArray(name) && name.length > 0) {
				name = name[0];
			}

			return name;
		},
		lastNameFormatted() {
			let name = this.lastName;

			//the user lastName prop may be an array of names that come from Employee and Global Employee
			if (Array.isArray(name) && name.length > 0) {
				name = name[0];
			}

			return name;
		},
		userInitials() {
			let result = 'test';

			if (this.firstNameFormatted && this.firstNameFormatted.length > 0) {
				result = this.firstNameFormatted.substring(0, 1);
			}

			if (this.lastNameFormatted && this.lastNameFormatted.length > 0) {
				result += this.lastNameFormatted.substring(0, 1);
			}

			return result;
		},
		showImage() {
			let result = false;

			if (this.imageSrc) {
				result = this.imageLoaded;
			}

			return result;
		}
	},
	methods: {
		onImageError() {
			this.imageLoaded = false;
		},
		onImageLoad() {
			this.imageLoaded = true;
		}
	}
};
</script>

<style lang="scss" scoped>
.profile {
	height: 30px;
	width: 30px;
	min-width: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: var(--brand-1);
	border: 2px solid var(--brand-2);
	border-radius: 50%;
	overflow: hidden;

	&__image {
		width: 100%;
		height: auto;
	}

	&__initials {
		font-weight: 700;
		font-size: 12px;
		line-height: 30px;
		color: var(--bg-brand-1-fg-2);
	}
}
</style>
